import { z } from 'zod';

export const importWalletRequest = z.object({
  params: z.object({
    teamId: z.string(),
    projectId: z.string(),
  }),
  body: z.object({
    addresses: z.array(z.string().min(1, 'Address is required')),
    writeKey: z.string().min(1, 'SDK Write key is required'),
  }),
});

export type ImportWalletRequest = z.infer<typeof importWalletRequest>;

export type ImportWalletResponse = null;
